<template>
  <v-dialog v-model="navigation.CRMWhatsappMediaCatalogDialogIsVisible" :max-width="navigation.deleteCRMWhatsappMediaCatalog ? '40vw' : '65vw'" :persistent="navigation.insertCRMWhatsappMediaCatalog || navigation.updateCRMWhatsappMediaCatalog" @update:model-value="navigation.CRMWhatsappMediaCatalogDialogIsVisible == false && closeCRMWhatsappMediaCatalogDialog()">
    <v-card :max-width="navigation.deleteCRMWhatsappMediaCatalog ? '40vw' : '65vw'">
      <div v-if="loader.insertCRMWhatsappMediaCatalog || loader.updateCRMWhatsappMediaCatalog || loader.deleteCRMWhatsappMediaCatalog" style="width: 100%; text-align: center; padding: 15px;">
        <v-progress-circular color="primary" indeterminate></v-progress-circular>
      </div>
      <div v-else>
        <div v-if="navigation.deleteCRMWhatsappMediaCatalog">
          <v-alert type="error" variant="tonal" style="cursor: default; user-select: none;">
            <template v-slot:title>
              <h3>ATENCIÓN</h3>
            </template>
            <p style="margin-top: 5px;">El catálogo multimedia <strong>{{ navigation.CRMWhatsappMediaCatalog.CRMWhatsappMediaCatalogName }}</strong> será eliminado junto con todos sus contenidos multimedia</p>
            <p>Esta acción es irreversible</p>
            <v-checkbox v-model="input.deleteCRMWhatsappMediaCatalogConfirmation" color="error" label="Estoy de acuerdo" hide-details></v-checkbox>
            <v-btn @click="deleteCRMWhatsappMediaCatalog()" :disabled="!input.deleteCRMWhatsappMediaCatalogConfirmation" color="error" dark block height="38" style="margin-top: 15px;">
              <h3>ELIMINAR CATÁLOGO MULTIMEDIA</h3>
              <v-icon style="margin-left: 10px;" dark right>mdi-delete</v-icon>
            </v-btn>
            <v-btn @click="closeCRMWhatsappMediaCatalogDialog()" color="primary" dark block height="38" style="margin-top: 15px;">
              <h3>CANCELAR</h3>
              <v-icon style="margin-left: 10px;" dark right>mdi-close-circle</v-icon>
            </v-btn>
          </v-alert>
        </div>
        <div v-else style="padding: 15px;">
          <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
            <template v-slot:activator="{ props }">
              <v-switch 
                v-bind="props" 
                v-model="input.CRMWhatsappMediaCatalogIsVisible" 
                color="primary" 
                :label="`El catálogo multimedia ${navigation.updateCRMWhatsappMediaCatalog ? 'es' : 'será'} visible${navigation.updateCRMWhatsappMediaCatalog ? '' : ' desde su creación'}`" 
                hide-details
                style="margin-bottom: 15px;"
              ></v-switch>
            </template>
            <span style="max-width: 400px; display: block;">La visibilidad del catálogo multimedia determina si un catálogo multimedia será o no visible desde otras partes de la aplicación que no sea la vista de catálogos multimedia</span>
          </v-tooltip>
          <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
            <template v-slot:activator="{ props }">
              <v-text-field 
                v-bind="props"
                ref="CRMWhatsappMediaCatalogName"
                v-model="input.CRMWhatsappMediaCatalogName" 
                :append-inner-icon="input.CRMWhatsappMediaCatalogName && /\S/.test(input.CRMWhatsappMediaCatalogName) ? 'mdi-alphabetical-variant-off' : 'mdi-alphabetical-variant'" 
                @click:append-inner="$generalFunctions.default.blurInput(this, 'CRMWhatsappMediaCatalogName'); input.CRMWhatsappMediaCatalogName = null" 
                label="Nombre del catálogo multimedia" 
                variant="solo-filled" 
                density="compact"
                autocomplete="off"
                hide-details
                style="margin-bottom: 15px;"
              ></v-text-field>
            </template>
            <span style="max-width: 400px; display: block;">El nombre del catálogo multimedia. Se recomienda no repetir nombres para facilitar su diferenciación</span>
          </v-tooltip>
          <v-tooltip :disabled="systemInformationData.tooltipDisabled" open-delay="2000" location="top">
            <template v-slot:activator="{ props }">
              <v-textarea 
                v-bind="props"
                ref="CRMWhatsappMediaCatalogDescription"
                v-model="input.CRMWhatsappMediaCatalogDescription" 
                :append-inner-icon="input.CRMWhatsappMediaCatalogDescription && /\S/.test(input.CRMWhatsappMediaCatalogDescription) ? 'mdi-alphabetical-off' : 'mdi-alphabetical'" 
                @click:append-inner="$generalFunctions.default.blurInput(this, 'CRMWhatsappMediaCatalogDescription'); input.CRMWhatsappMediaCatalogDescription = null" 
                label="Descripción del catálogo multimedia (opcional)" 
                variant="solo-filled" 
                density="compact"
                max-rows="5"
                rows="3"
                auto-grow
                autocomplete="off"
                hide-details
                style="margin-bottom: 15px;"
              ></v-textarea>
            </template>
            <span style="max-width: 400px; display: block;">La descripción del catálogo multimedia. Es un espacio opcional destinado a detallar el contenido o función del catálogo multimedia</span>
          </v-tooltip>
          <br>
          <v-tooltip :disabled="validateInputForCRMWhatsappMediaCatalog(false).success" location="top"> 
            <template v-slot:activator="{ props }">
              <div v-bind="props">
                <v-btn @click="navigation.insertCRMWhatsappMediaCatalog ? insertCRMWhatsappMediaCatalog() : updateCRMWhatsappMediaCatalog()" :disabled="!validateInputForCRMWhatsappMediaCatalog(false).success" :color="navigation.insertCRMWhatsappMediaCatalog ? 'success' : 'warning'" dark block height="38" style="margin-bottom: 10px;">
                  <h3>{{ navigation.insertCRMWhatsappMediaCatalog ? 'AGREGAR' : 'ACTUALIZAR' }} CATÁLOGO MULTIMEDIA</h3>
                  <v-icon style="margin-left: 10px;" dark right>{{ navigation.insertCRMWhatsappMediaCatalog ? 'mdi-plus-circle' : 'mdi-update' }}</v-icon>
                </v-btn>
              </div>
            </template>
            <span style="max-width: 400px; display: block;">{{ validateInputForCRMWhatsappMediaCatalog(false).result }}</span>
          </v-tooltip>
          <v-btn @click="closeCRMWhatsappMediaCatalogDialog()" color="error" dark block height="38">
            <h3>CANCELAR</h3>
            <v-icon style="margin-left: 10px;" dark right>mdi-close-circle</v-icon>
          </v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>
  
<style scoped>
</style>

<script>
  import { systemInformation } from '@/utilities/systemInformation';
  export default {
    inject: ['$generalFunctions', '$displayFunctions'],
    components: {},

    data: () => 
    ({
      input: 
      {
        CRMWhatsappMediaCatalogIsVisible: true,
        CRMWhatsappMediaCatalogName: null,
        CRMWhatsappMediaCatalogDescription: null,
        deleteCRMWhatsappMediaCatalogConfirmation: false
      },
      navigation: 
      {
        CRMWhatsappMediaCatalog: null,
        insertCRMWhatsappMediaCatalog: false,
        updateCRMWhatsappMediaCatalog: false,
        deleteCRMWhatsappMediaCatalog: false,
        CRMWhatsappMediaCatalogDialogIsVisible: false
      },
      loader: 
      {
        insertCRMWhatsappMediaCatalog: false,
        updateCRMWhatsappMediaCatalog: false,
        deleteCRMWhatsappMediaCatalog: false
      },
      systemInformationData: 
      {
        CRMAccountID: null,
        CRMAgentID: null,
        tooltipDisabled: false,
        updateSubscription: null
      },
    }),

    methods:
    {
      async insertCRMWhatsappMediaCatalog(){
        if (this.validateInputForCRMWhatsappMediaCatalog(true).success){
          this.loader.insertCRMWhatsappMediaCatalog = true;
          const insertCRMWhatsappMediaCatalogRequestQuery = 
          {
            'localStorage':
            {
              'CRMAccountID': this.systemInformationData.CRMAccountID,
              'CRMAgentID': this.systemInformationData.CRMAgentID,
            },
            'CRMWhatsappMediaCatalogName': this.input.CRMWhatsappMediaCatalogName,
            'CRMWhatsappMediaCatalogDescription': this.input.CRMWhatsappMediaCatalogDescription,
            'CRMWhatsappMediaCatalogIsVisible': this.input.CRMWhatsappMediaCatalogIsVisible
          };
          const insertCRMWhatsappMediaCatalogResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappMediaCatalog/functions/insertCRMWhatsappMediaCatalog', insertCRMWhatsappMediaCatalogRequestQuery);
          if (insertCRMWhatsappMediaCatalogResult.success){
            this.$root.notificationDialog.showSystemNotificationDialog('insertCRMWhatsappMediaCatalog_success', 'success', 'Se ha agregado el catálogo multimedia exitosamente', null, true);
            this.closeCRMWhatsappMediaCatalogDialog();
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog(insertCRMWhatsappMediaCatalogResult.result, 'error', 'Ha ocurrido un error inesperado al agregar el catálogo multimedia, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
          }
          this.loader.insertCRMWhatsappMediaCatalog = false;
        }
      },

      async updateCRMWhatsappMediaCatalog(){
        if (this.validateInputForCRMWhatsappMediaCatalog(true).success){
          this.loader.updateCRMWhatsappMediaCatalog = true;
          const updateCRMWhatsappMediaCatalogRequestQuery = 
          {
            'localStorage':
            {
              'CRMAccountID': this.systemInformationData.CRMAccountID,
              'CRMAgentID': this.systemInformationData.CRMAgentID,
            },
            'CRMWhatsappMediaCatalogID': this.navigation.CRMWhatsappMediaCatalog.CRMWhatsappMediaCatalogID,
            'CRMWhatsappMediaCatalogName': this.input.CRMWhatsappMediaCatalogName,
            'CRMWhatsappMediaCatalogDescription': this.input.CRMWhatsappMediaCatalogDescription,
            'CRMWhatsappMediaCatalogIsVisible': this.input.CRMWhatsappMediaCatalogIsVisible
          };
          const updateCRMWhatsappMediaCatalogResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappMediaCatalog/functions/updateCRMWhatsappMediaCatalog', updateCRMWhatsappMediaCatalogRequestQuery);
          if (updateCRMWhatsappMediaCatalogResult.success){
            this.$root.notificationDialog.showSystemNotificationDialog('updateCRMWhatsappMediaCatalog_success', 'success', 'Se ha actualizado el catálogo multimedia exitosamente', null, true);
            this.closeCRMWhatsappMediaCatalogDialog();
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog(updateCRMWhatsappMediaCatalogResult.result, 'error', 'Ha ocurrido un error inesperado al actualizar el catálogo multimedia, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
          }
          this.loader.updateCRMWhatsappMediaCatalog = false;
        }
      },

      async deleteCRMWhatsappMediaCatalog(){
        if (this.validateInputForCRMWhatsappMediaCatalog(true).success){
          this.loader.deleteCRMWhatsappMediaCatalog = true;
          const deleteCRMWhatsappMediaCatalogRequestQuery = 
          {
            'localStorage':
            {
              'CRMAccountID': this.systemInformationData.CRMAccountID,
              'CRMAgentID': this.systemInformationData.CRMAgentID,
            },
            'CRMWhatsappMediaCatalogID': this.navigation.CRMWhatsappMediaCatalog.CRMWhatsappMediaCatalogID
          };
          const deleteCRMWhatsappMediaCatalogResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappMediaCatalog/functions/deleteCRMWhatsappMediaCatalog', deleteCRMWhatsappMediaCatalogRequestQuery);
          if (deleteCRMWhatsappMediaCatalogResult.success){
            this.$root.notificationDialog.showSystemNotificationDialog('deleteCRMWhatsappMediaCatalog_success', 'success', 'Se ha eliminado el catálogo multimedia exitosamente', null, true);
            this.closeCRMWhatsappMediaCatalogDialog();
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog(deleteCRMWhatsappMediaCatalogResult.result, 'error', 'Ha ocurrido un error inesperado al eliminar el catálogo multimedia, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
          }
          this.loader.deleteCRMWhatsappMediaCatalog = false;
        }
      },

      validateInputForCRMWhatsappMediaCatalog(showSystemNotificationDialog){
        const regularExpressionChecker = /\S/;
        if (this.navigation.deleteCRMWhatsappMediaCatalog){
          return {success: true, result: null};
        } else if (this.input.CRMWhatsappMediaCatalogName == null || !regularExpressionChecker.test(this.input.CRMWhatsappMediaCatalogName)){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMWhatsappMediaCatalog_CRMWhatsappMediaCatalogName', 'warning', 'El nombre del catálogo multimedia es obligatorio', null, true);
          return {success: false, result: 'El nombre del catálogo multimedia es obligatorio'};
        } else if (this.input.CRMWhatsappMediaCatalogName.length > 30){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMWhatsappMediaCatalog_CRMWhatsappMediaCatalogName', 'warning', 'El nombre del catálogo multimedia no puede exceder los 30 caracteres de longitud', null, true);
          return {success: false, result: 'El nombre del catálogo multimedia no puede exceder los 30 caracteres de longitud'};
        } else if (this.input.CRMWhatsappMediaCatalogDescription != null && this.input.CRMWhatsappMediaCatalogDescription.length > 65535){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMWhatsappMediaCatalog_CRMWhatsappMediaCatalogDescription', 'warning', 'La descripción del catálogo multimedia no puede exceder los 65535 caracteres de longitud', null, true);
          return {success: false, result: 'La descripción del catálogo multimedia no puede exceder los 65535 caracteres de longitud'};
        }
        return {success: true, result: null};
      },

      async getSystemInformationData(){
        try {
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){
            this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformationData.CRMAgentID = systemInformation.getCRMAgentID;
            this.systemInformationData.tooltipDisabled = systemInformation.getTooltipDisabled;
            this.systemInformationData.updateSubscription = systemInformation.subscribeToUpdate((updatedSystemInformationData) => {
              this.systemInformationData.tooltipDisabled = updatedSystemInformationData.tooltipDisabled;
            });
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformationData_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
          }
        } catch {
          this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformationData_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
        }
      },

      async openCRMWhatsappMediaCatalogDialog(CRMWhatsappMediaCatalog, insertCRMWhatsappMediaCatalog, updateCRMWhatsappMediaCatalog, deleteCRMWhatsappMediaCatalog){
        await this.getSystemInformationData();
        this.navigation.CRMWhatsappMediaCatalog = CRMWhatsappMediaCatalog;
        this.navigation.insertCRMWhatsappMediaCatalog = insertCRMWhatsappMediaCatalog;
        this.navigation.updateCRMWhatsappMediaCatalog = updateCRMWhatsappMediaCatalog;
        this.navigation.deleteCRMWhatsappMediaCatalog = deleteCRMWhatsappMediaCatalog;
        this.input.CRMWhatsappMediaCatalogIsVisible = this.navigation.CRMWhatsappMediaCatalog ? this.navigation.CRMWhatsappMediaCatalog.CRMWhatsappMediaCatalogIsVisible == 1 : true;
        this.input.CRMWhatsappMediaCatalogName = this.navigation.CRMWhatsappMediaCatalog ? this.navigation.CRMWhatsappMediaCatalog.CRMWhatsappMediaCatalogName : null;
        this.input.CRMWhatsappMediaCatalogDescription = this.navigation.CRMWhatsappMediaCatalog ? this.navigation.CRMWhatsappMediaCatalog.CRMWhatsappMediaCatalogDescription : null;
        this.input.deleteCRMWhatsappMediaCatalogConfirmation = false;
        this.loader.insertCRMWhatsappMediaCatalog = false;
        this.loader.updateCRMWhatsappMediaCatalog = false;
        this.loader.deleteCRMWhatsappMediaCatalog = false;
        this.navigation.CRMWhatsappMediaCatalogDialogIsVisible = true;
        this.$generalFunctions.default.focusInput(this, 'CRMWhatsappMediaCatalogName');
      },

      closeCRMWhatsappMediaCatalogDialog(){
        this.navigation.CRMWhatsappMediaCatalogDialogIsVisible = false;
        if (this.systemInformationData.updateSubscription){
          systemInformation.unsubscribeFromUpdate(this.systemInformationData.updateSubscription);
          this.systemInformationData.updateSubscription = null;
        }
        this.$emit('closeCRMWhatsappMediaCatalogDialog');
      }
    },

    mounted(){},

    beforeUnmount(){
      if (this.systemInformationData.updateSubscription){
        systemInformation.unsubscribeFromUpdate(this.systemInformationData.updateSubscription);
        this.systemInformationData.updateSubscription = null;
      }
    }
  }
</script>